import React, { PureComponent } from 'react';

import { getPropsOrDefault } from '../../common/utils.jsx';
import { resetFieldValue, setFieldValue } from '../app.reducer.jsx';
import { bindActionCreators } from '../app.store.jsx';

const UNKNOWN = 'UNKNOWN';

export default class FormPureComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.isVisible = this.isVisible.bind(this);
    //this.getDisplayStyle = this.getDisplayStyle.bind(this);
    this._setFieldValue = bindActionCreators(setFieldValue);
    this._resetFieldValue = bindActionCreators(resetFieldValue);
  }

  onChangeHandler(eventOrValue) {
    const {name, value: propsValue, disabled} = this.props;
    if (disabled) {
      return;
    }
    const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;
    const root = this.props.root || getPropsOrDefault(this, 'props.props.root', undefined);
    if ('function' === typeof this.props.onChangeCallback) {
      this.props.onChangeCallback(name, value, root);
    } else if (UNKNOWN === propsValue && UNKNOWN === value) {
      this._resetFieldValue(name, root);
    } else {
      this._setFieldValue(name, value, root);
    }
  }

  isVisible() {
    const {condition, fieldValues} = this.props;
    let isVisible = true;
    if ('function' === typeof condition) {
      isVisible = condition(fieldValues);
    }
    return isVisible;
  }
}

export class FormPureComponentItem extends PureComponent {
  constructor() {
    super();
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler() {
    this.props.onChangeCallback(this.props.value);
  }
}
